import { GetSecurityQuoteAction } from 'phoenix/redux/actions';
import { WatchlistSecurity } from 'phoenix/redux/models/Watchlists';
import { QualifiedId } from 'phoenix/util/QualifiedId';
import { XS } from 'phoenix/xstream/XS';
import { useXstreamDispatch } from 'phoenix/xstream/XstreamProvider';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { Flex } from '../..';
import { DescriptionLabel, SymbolLabel } from '../Shared/Labels';
import { SecurityCellLogo } from '../Shared/SecurityCellLogo';
import { SecurityNameSection } from '../Shared/SecurityNameSection';
import style from '../style.module.scss';
import { SecurityValue } from './SecurityValue';

export interface MutualFundWatchlistCellProps {
    getCached?: boolean;
    onDelete?: (watchlistId?: any) => void;
    security?: WatchlistSecurity;
    streamingNamespace?: string;
    symbol: string;
    visible?: boolean;
}

export const MutualFundWatchlistCell = React.memo((props: MutualFundWatchlistCellProps) => {
    const xdispatch = useXstreamDispatch();
    const dispatch = useDispatch();

    const { streamingNamespace = '', security, symbol } = props;

    const { ref, inView } = useInView({ trackVisibility: true, threshold: 0, delay: 400 });
    const [subscription, setSubscription] = useState<string>('');

    useEffect(() => {
        dispatch(GetSecurityQuoteAction(symbol));
    }, [symbol, inView]);

    useEffect(() => {
        const run = async () => {
            if (inView && !subscription) {
                const ticket: string = await xdispatch(XS.Quotes.start(symbol, streamingNamespace));
                setSubscription(ticket);
            } else if (!inView) {
                XS.stop(subscription);
                setSubscription('');
            } else {
                await dispatch(GetSecurityQuoteAction(symbol));

                if (!subscription) {
                    const ticket: string = await xdispatch(XS.Quotes.start(symbol, streamingNamespace));
                    setSubscription(ticket);
                }
            }
        };

        run();
        return () => {
            XS.stop(subscription);
        };
    }, [inView]);

    const [latestChartPercChange] = useState();
    const [latestChartPrice] = useState();
    const secName = security?.name ? security?.name : ''
    return (
        <>
            <SecurityCellLogo symbol={symbol} />
            <Flex ref={ref} column className={style.cellContent}>
                <Flex className={style.mainRow}>
                    <SecurityNameSection>
                        <SymbolLabel tooltipText={`${secName} (${symbol})`}>{secName.toUpperCase()}</SymbolLabel>
                        <DescriptionLabel>{`${QualifiedId.RemovePrefix(symbol)}`}</DescriptionLabel>
                    </SecurityNameSection>
                    <SecurityValue withQuoteOverride chartPercChange={latestChartPercChange} chartPrice={latestChartPrice} symbol={symbol} />
                </Flex>
            </Flex>
        </>
    );
});
